import { cn } from '@/lib/utils';
import { TranslationNamespace } from '@/types/translation-namespace';
import { CheckCircle2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SignUpSuccessProps {
  /** Disabled in the iframe embed, where the height follows the content. */
  fullHeight?: boolean;
}

export function SignUpSuccess({ fullHeight = true }: SignUpSuccessProps) {
  const { t } = useTranslation(TranslationNamespace.SIGN_UP);

  return (
    <div
      className={cn(
        'flex items-center justify-center bg-gray-50 p-4',
        fullHeight ? 'min-h-screen' : 'py-12',
      )}
    >
      <div className="w-full max-w-md rounded-lg bg-white p-8 text-center shadow-lg">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-brand-sky/20">
          <CheckCircle2 className="h-10 w-10 text-brand-sky" />
        </div>
        <h2 className="mb-2 text-2xl font-bold text-secondary">
          {t('success.title')}
        </h2>
        <p className="mb-6 text-secondary">{t('success.description')}</p>
        <button
          onClick={() => window.location.reload()}
          className="cursor-pointer rounded-lg bg-secondary px-6 py-3 text-white transition-all hover:bg-secondary-hover"
        >
          {t('success.cta')}
        </button>
      </div>
    </div>
  );
}
